import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    id: String,
    autoShow: Boolean,
    oneTime: Boolean
  }

  connect() {
    if (this.autoShowValue === undefined) {
      this.autoShowValue = true
    }

    if (this.autoShowValue && this.shouldShow()) {
      this.show()
    }
  }

  show() {
    this.modalTarget.style.display = 'flex'
  }

  hide() {
    this.modalTarget.style.display = 'none'
    if (this.oneTimeValue) {
      this.setCookie()
    }
  }

  setCookieAndNavigate(event) {
    if (this.oneTimeValue) {
      this.setCookie()
    }
  }

  shouldShow() {
    return !this.oneTimeValue || !this.hasSeenModal()
  }

  get cookieName() {
    return `${this.idValue}_seen`
  }

  hasSeenModal() {
    return document.cookie.split(';').some(cookie => 
      cookie.trim().startsWith(`${this.cookieName}=`)
    )
  }

  setCookie() {
    document.cookie = `${this.cookieName}=true; max-age=31536000; path=/`
  }
} 